<template>
  <div :class="$style.breadcrumbs">
    <div :class="$style.path">
      <router-link to="/">Inicio</router-link>
      <template v-for="(item, index) in breadcrumb">
        <span v-if="(index != 0) && (index < breadcrumb.length-1)" :key="index">
          <span :class="$style.arrow"></span>
          <span v-if="item.url==''">
            <span>{{item.title}}</span>
          </span>
          <span v-else>
            <router-link :to="item.url">{{item.title}}</router-link>
          </span>
          <!-- <span :class="$style.arrow"></span>
          <span>{{item.title}}</span> -->
        </span>
      </template>
      <span v-if="activeItem">
        <span :class="$style.arrow"></span>
        <strong :class="$style.current">{{activeItem.title}}</strong>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getDataBreadcrumbs } from '@/services/breadcrumbs'
// import reduce from 'lodash/reduce'

export default {
  name: 'breadcrumbs',
  data() {
    return {
      breadcrumb: [],
      activeItem: {},
      path: [],
    }
  },
  computed: {
    ...mapState(['settings']),
    menuData() {
      return getDataBreadcrumbs
    },
  },
  methods: {
    getA(data, name) {
      if (data.name === name) {
        return [data]
      }
      if (data.children) {
        for (const i of data.children) {
          const a = this.getA(i, name)
          if (a) {
            return [{
              title: data.title,
              url: data.url,
            }].concat(a)
          }
        }
        return false
      }
      return false
    },
    getPath(data, url, parents = []) {
      const items = this.getA(data, url)
      this.activeItem = items[items.length - 1]
      return items
    },
  },
  mounted: function () {
    this.breadcrumb = this.getPath(this.menuData, this.$route.name)
  },
  watch: {
    $route(to) {
      this.breadcrumb = this.getPath(this.menuData, to.name)
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
